
import { AllRoutes } from './AllRoutes/AllRoutes';
import './App.css';

function App() {
  return (
    <div>
    <AllRoutes/>
    </div>
  );
}

export default App;
